module.exports = __webpack_public_path__ + "static/img/3-1.024f05b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/3-1.jpg
// module id = y0rq
// module chunks = 25